export default __webpack_public_path__ + "static/media/Simulator Screen Shot - iPhone 13 Pro Max - 2022-10-08 at 12.52.2220b5ec.png";